import { L1Types, base58toUint8Array, bech32toUint8Array, hexToUint8Array, uint8ArrayToBase58, uint8ArrayToBech32, uint8ArrayToHexStr, } from '@pactswap/cwap-cm-lib/shared';
import { AddressEncoding, BtcLikeNetworkParams } from '../constants';
export const getAddressEncoding = (address, l1ChainType) => {
    const bech32Prefixes = Object.values(BtcLikeNetworkParams)
        .map((network) => network.bech32)
        .filter(Boolean);
    switch (l1ChainType) {
        case L1Types.Evm:
            return AddressEncoding.Hex;
        case L1Types.Btc: {
            switch (true) {
                case bech32Prefixes.some((prefix) => address.startsWith(`${prefix}1p`)):
                    return AddressEncoding.Bech32m;
                case bech32Prefixes.some((prefix) => address.startsWith(`${prefix}1`)):
                    return AddressEncoding.Bech32;
                default:
                    break;
            }
            return AddressEncoding.Base58;
        }
        default:
            throw new Error(`Unknown chain type ${l1ChainType}`);
    }
};
export const encodeAddress = (address, encoding) => {
    switch (encoding) {
        case AddressEncoding.Hex:
            return hexToUint8Array(address);
        case AddressEncoding.Base58:
            return base58toUint8Array(address);
        case AddressEncoding.Bech32:
            return bech32toUint8Array(address, 0);
        case AddressEncoding.Bech32m:
            return bech32toUint8Array(address, 1);
        default:
            throw new Error(`Unknown address encoding ${encoding}`);
    }
};
export const decodeAddress = (byteArr, encoding, networkParams) => {
    switch (encoding) {
        case AddressEncoding.Hex:
            return uint8ArrayToHexStr(byteArr);
        case AddressEncoding.Base58:
            return uint8ArrayToBase58(byteArr);
        case AddressEncoding.Bech32: {
            if (!networkParams) {
                throw new Error(`Shard or Network Params is required for bech32 address decoding`);
            }
            return uint8ArrayToBech32(byteArr, networkParams.bech32, 0);
        }
        case AddressEncoding.Bech32m: {
            if (!networkParams) {
                throw new Error(`Shard or Network Params is required for bech32m address decoding`);
            }
            return uint8ArrayToBech32(byteArr, networkParams.bech32, 1);
        }
        default:
            throw new Error(`Unknown address encoding ${encoding}`);
    }
};
